import { ToastrService } from 'ngx-toastr';
import { ErrorToast, SuccessToast } from 'dp-formio';

export function showToast(toastrService: ToastrService, title: string, message: string, isError: boolean) {
    toastrService.show(message, title, {
        toastClass: "notification-toast",
        closeButton: true,
        enableHtml: true,
        toastComponent: isError ? ErrorToast : SuccessToast,
    });
}